export class PageConfig {
	public defaults: any = {
		app:{
			tableaudebord: {
				page: {
					title: 'utool-Distributeur',
					desc: 'Tableau de bord et Statistiques'
				},
			},
			modules : {
				page:{
					title : 'Paramètrages',
					desc: 'Gestion Tarifs Modules & Options',
				}
			},
			packages : {
				page:{
					title : 'Paramètrages',
					desc: 'Gestion Pack Commercials',
				}
			}
		}
	};

	public get configs(): any {
		return this.defaults;
	}
}
